<template>
    <v-list-tile
            avatar
            class="conversation-preview"
            :data-qe-id="`messenger-conversation-preview-${conversation.id}`">
        <v-list-tile-avatar class="conversation-preview__avatars messenger-avatar" size="40">
            <img
                    v-if="otherParticipants[0]"
                    :src="otherParticipants[0].profileImageUrl"
                    :onerror="imageErrorFallback(otherParticipants[0].fallbackProfileImageUrl)">
            <div
                    class="conversation-preview__overlay-avatar"
                    v-if="otherParticipants[0] && otherParticipants[1]">
                <img
                        :src="otherParticipants[1].profileImageUrl"
                        :onerror="imageErrorFallback(otherParticipants[1].fallbackProfileImageUrl)">
            </div>
        </v-list-tile-avatar>
        <v-list-tile-content>
            <v-list-tile-title :class="{ 'italic': otherParticipants.length === 0 }">
                {{conversationTitle}}
            </v-list-tile-title>
            <v-list-tile-sub-title>
                {{conversationSubTitle}}
            </v-list-tile-sub-title>
            <v-list-tile-sub-title
                    :class="{
            'conversation-list__preview-text--unread': unReadMessages.length
          }">
                {{conversationPreview}}
            </v-list-tile-sub-title>
        </v-list-tile-content>
        <v-list-tile-action>
            <slot name="actions"></slot>
            <span class="unread-messages-notifications"
                  v-if="showNotification"
                  :data-qe-id="`${conversation.id}_unread-messages-notifications`">
                {{unReadMessages.length}}
            </span>
        </v-list-tile-action>
    </v-list-tile>
</template>

<script>
    import { conversationTitle, isGroupConversation, unReadMessages } from '../iam.utils';
    import { mapGetters } from 'vuex';
    import { storeGetters } from '../../../store/storeGetters.constant';
    import { iamConstants } from "../iam.constant";
    import { imageErrorFallback } from "../../../common/utils/utils";

    export default {
        name: 'ConversationPreview',
        props: {
            conversation: {
                type: Object,
            },
            activeConversationId: {
                type: String,
            },
        },
        data() {
            return {
                failedImages: {},
            };
        },
        computed: {
            ...mapGetters('messenger', {
                messengerUsername: storeGetters.messengerUsername,
            }),
            singleUserPresence() {
                const others = Object.keys(this.conversation.participants)
                    .filter(k => k !== this.messengerUsername);

                if (others.length !== 1) {
                    return null;
                }

                return this.conversation.participants[others[0]].presence;
            },
            otherParticipants() {
                return Object.keys(this.conversation.participants)
                    .filter(k => k.toLowerCase() !== this.messengerUsername)
                    .map(k => this.conversation.participants[k]);
            },
            conversationTitle() {
                let title = '';
                if (this.conversation && this.conversation.participants) {
                    if (this.conversation.id === iamConstants.DRAFT_CHAT_ID
                        || !isGroupConversation(this.conversation)) {
                        title = conversationTitle(this.otherParticipants, this.conversation.id);
                    } else {
                        title = this.conversation.name;
                    }
                }
                return title;
            },
            conversationSubTitle() {
                if (this.otherParticipants.length === 0) {
                    return '';
                } else if (this.otherParticipants.length === 1) {
                    return this.otherParticipants[0].primaryChapterName;
                }
                return `+${this.otherParticipants.length}`;
            },
            conversationPreview() {
                const msgs = this.conversation.events
                    .filter(e => this.isMessage(e));
                return (
                    (msgs && msgs.length &&
                        msgs[msgs.length - 1].messageText) ||
                    ''
                );
            },
            unReadMessages() {
                return unReadMessages(this.conversation);
            },
            showNotification() {
                return this.unReadMessages && this.unReadMessages.length
                    && this.conversation && this.conversation.id !== this.activeConversationId;
            },
        },
        methods: {
            imageErrorFallback,
            isMessage(event) {
                return event.type === 'message';
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../../common/styles/_colors.scss';

    .conversation-preview {
        max-width: 400px;

        &__overlay-avatar {
            height: 30px;
            width: 30px;
            position: absolute;
            left: 20px;
            bottom: 0;
        }

        .unread-messages-notifications {
            font-size: 12px;
            font-weight: 600;
            color: $ypo-blue;
            padding: 0 5px;
            border-radius: 50%;
            background-color: $ypo-gold;
        }
    }
</style>

